var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcelicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.86098 2.72292L15.431 0.927918C15.5018 0.917754 15.574 0.922922 15.6427 0.943073C15.7114 0.963224 15.775 0.997889 15.8291 1.04472C15.8832 1.09156 15.9267 1.14947 15.9565 1.21454C15.9863 1.27962 16.0018 1.35034 16.002 1.42192V22.2699C16.0018 22.3414 15.9863 22.412 15.9566 22.477C15.9268 22.542 15.8835 22.5999 15.8294 22.6467C15.7754 22.6935 15.712 22.7282 15.6434 22.7484C15.5749 22.7686 15.5028 22.7739 15.432 22.7639L2.85998 20.9689C2.6216 20.935 2.40347 20.8161 2.24567 20.6343C2.08786 20.4524 2.00098 20.2197 2.00098 19.9789V3.71292C2.00098 3.47213 2.08786 3.23943 2.24567 3.05756C2.40347 2.87569 2.6226 2.75687 2.86098 2.72292ZM17.002 2.84592H21.002C21.2672 2.84592 21.5215 2.95128 21.7091 3.13881C21.8966 3.32635 22.002 3.5807 22.002 3.84592V19.8459C22.002 20.1111 21.8966 20.3655 21.7091 20.553C21.5215 20.7406 21.2672 20.8459 21.002 20.8459H17.002V2.84592ZM10.202 11.8459L13.002 7.84592H10.602L9.00198 10.1319L7.40198 7.84592H5.00198L7.80198 11.8459L5.00198 15.8459H7.40198L9.00198 13.5599L10.602 15.8459H13.002L10.202 11.8459Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelicon);
export default __webpack_public_path__ + "static/media/excel.icon.f3c7443961c3d0ec2ffcd83e7ca5d040.svg";
export { ForwardRef as ReactComponent };